import { Routes } from 'config/routes';
import { PermissionsEnum } from 'gql/types';
import InternalUsersTable from 'modules/admin/components/InternalUsersTable';
import PermissionsTable from 'modules/admin/components/PermissionsTable';
import { ITabsItem } from 'modules/common/components/CardTabs';
import { InvitationsTable } from 'modules/invitations/components';
import NavigationCardTabs from 'modules/navigation/components/NavigationCardTabs';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const UsersCardTabs: FC = () => {
  const { t } = useTranslation('admin.UsersListPage');
  const currentUser = useCurrentUser();
  const isManagePermissionsAllowed = currentUser.isCan(
    PermissionsEnum.ManagePermissions
  );
  const isViewInvitationsAllowed = currentUser.isCan(PermissionsEnum.AddUsers);

  const internalUsers: ITabsItem = {
    title: t('users'),
    content: <InternalUsersTable />,
    key: Routes.Users,
  };

  const permissionsTable: ITabsItem = {
    title: t('permissions'),
    content: <PermissionsTable />,
    key: Routes.UsersPermissions,
  };

  const invitationsTable: ITabsItem = {
    title: t('invitations'),
    content: <InvitationsTable />,
    key: Routes.Invitations,
  };

  return (
    <NavigationCardTabs
      items={[
        internalUsers,
        ...(isManagePermissionsAllowed ? [permissionsTable] : []),
        ...(isViewInvitationsAllowed ? [invitationsTable] : []),
      ]}
    />
  );
};

export default UsersCardTabs;
